






























































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
@Component
export default class VariableInput extends ApiAccessBase {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private innerLabel: string = '';
  private rules: any;
  private clearable: boolean = false;
  private counter: string | boolean = false;
  private privateTextColor: string = '';
  private dummyValue = '';
  private header = [
    {
      text: 'address',
      align: 'left',
      value: 'address',
    },
  ];
  private dialogVisible: boolean = false;
  // (ts)親コンポーネントからデータを受け取るpropsは@Propデコレータ
  @Prop({default: false}) private isGroup?: boolean;
  @Prop() private grouplabel?: string;
  @Prop() private groupLayout?: string;
  @Prop() private label?: string;
  @Prop() private type?: string;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private prefix?: string;
  @Prop() private suffix?: string;
  @Prop() private placeholder?: string;
  @Prop() private hint?: string;
  @Prop() private size?: string;
  @Prop() private maxlength?: string;
  @Prop() private minlength?: string;
  @Prop() private pattern?: string;
  @Prop() private invaildMessage?: string;
  @Prop() private eventTargetName?: string;
  @Prop() private textColor?: string;
  @Prop() private index?: number;

  @Emit('input')
  private updateValue(value: string) {
    if (value === null) {
      value = '';
    }
    return value;
  }

  /**
   * 住所の検索
   */
  private searchAddressByPostalCode() {
    if (this.value === undefined || this.value === null || this.value === '') {
      alert('郵便番号を入力してください');
    } else {
    const sendValue: string = this.value.replace('-', '') ;
    this.apiAccess(Constants.KANRI_URL + '/postalcode-info'
      + '/' + sendValue, Constants.API_METHOD_GET, null, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        const addressList: any = this.resultData;
        //成功
        if (addressList.length === 0) {
          //住所が見つからなかった場合
          alert('住所が見つかりませんでした');
          this.selectAddress('');
        } else if (addressList.length === 1) {
          //1件のみhitした場合、そのまま住所をセット
          this.selectAddress(addressList[0].address);
        } else {
          //複数件hitした場合
          //ダイアログで表示する
          //ex. 同一郵便番号で複数住所が設定されている場合 0680546, 0791571, 4520961...
          this.dialogVisible = true;
        }
      } else {
          // 失敗
          alert(this.errorMessage);
      }
    });
    }
  }
  @Emit('emitAddress')
  private emitAddress(address: string, target?: string, index?: number) {
  }

  /**
   * 住所の設定
   */
  private selectAddress(address: string) {
    this.emitAddress(address, this.eventTargetName, this.index);
    this.dialogVisible = false;
  }

  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // ラベルの設定
    if (this.isGroup && this.label && this.groupLayout !== Constants.GROUP_LAYOUT_ARRAY) {
      this.innerLabel = this.label;
    }
    // クリアボタンの設定
    this.clearable = !(this.readonly || this.disabled);
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [
      (value: string) => (this.isValidateRequired(value)) || '必須項目です。',
      (value: string) => (this.isValidate(value)) || this.privateInvaildMessage,
      ];
    // 文字数カウンタの設定
    if (this.maxlength) {
      this.counter = this.maxlength;
    }
    // ダミー値の設定
    if (this.disabled && !this.value) {
      this.dummyValue = '　';
    }
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }
  private isValidate(value: string) {
    return this.validate.isValidate(value, this.maxlength, this.minlength, this.pattern);
  }
}
